import Excel from "exceljs"
import { saveAs } from "file-saver"
import { exportFileName } from "../../../../../../../../../../utils/exportFileName"
import {
  SafetiesDetailExcelSheetType,
  SafetyInfoHeaderType,
} from "../../../../../../../models/detail/export"
import { Translate } from "../../../../../../../../../../constant/Translate"
import { worksheetConfig as worksheetConfig1 } from "../worksheet1/worksheetConfig"
import { worksheetConfig as worksheetConfig2 } from "../worksheet2/worksheetConfig"
import { worksheetConfig as worksheetConfig3 } from "../worksheet3/worksheetConfig"

const { EXPORT_EP0197 } = Translate

export const exportFileExcel = async (
  data: SafetiesDetailExcelSheetType[],
  header: SafetyInfoHeaderType,
) => {
  const workbook = new Excel.Workbook()
  worksheetConfig1(data, header, workbook)
  worksheetConfig2(data, header, workbook)
  worksheetConfig3(data, header, workbook)

  const buffer = await workbook.xlsx.writeBuffer()
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  const fileExtension = ".xlsx"

  const blob = new Blob([buffer], { type: fileType })

  saveAs(blob, exportFileName(EXPORT_EP0197) + fileExtension)
}
